import { Messages } from '../const';
export default {
    ...Object.fromEntries(Object.values(Messages).map((message) => [message, message]))
};